import menu from './id-ID/menu';
import pages from './id-ID/pages';
import pwa from './id-ID/pwa';

export default {
  'navBar.lang': '语言',
  ...pages,
  ...menu,
  ...pwa,
};
